import InstagramEmbed from 'react-instagram-embed';
import { Post } from 'lib/types';
import { FB_ID, FB_CLIENT_TOKEN } from 'lib/constants';
import { useRef, useEffect, useState } from 'react';
import { EmbedFallback } from './EmbedFallback';

interface Props {
  post: Post;
}

export const InstagramEmbedWithFallback = ({ post }: Props) => {
  const [shouldFallback, setShouldFallback] = useState(false);
  const [doneRendering, setDoneRendering] = useState(false);

  const igRef = useRef(null);

  useEffect(() => {
    if (igRef.current && doneRendering) {
      try {
        if (!((igRef.current as any)?.state?.html)) {
          setShouldFallback(true);
        }
      } catch (err: any) {
        setShouldFallback(true);
      }
    }
    if (navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')) {
      setShouldFallback(true);
    }
  }, [igRef, doneRendering]);

  if (shouldFallback) {
    return <EmbedFallback post={post} />;
  }
  return (
    <InstagramEmbed
      ref={igRef}
      url={post.url}
      clientAccessToken={`${FB_ID}|${FB_CLIENT_TOKEN}`}
      maxWidth={600}
      hideCaption
      onFailure={() => setShouldFallback(true)}
      onAfterRender={() => setDoneRendering(true)}
    />
  );
};
